/**
 *  @class
 *  @function BeforeAfter
 */
if (!customElements.get('before-after')) {
	class BeforeAfter extends HTMLElement {
	  constructor() {
			super();
			this.parent = this.closest('.before-after-image') || this.closest('.product-single__media-before-after');
			// For product carousel, use the before-after element itself
			this.targetElement = this;
			this.slider = this.querySelector('.before-after-image--slider');
			this.position = this.slider.value;
			const _this = this;
			this.observer = new IntersectionObserver(function(entries) {
				if (entries[0].intersectionRatio > 0) {
		      gsap.to(_this.parent, {'--percent': `${_this.position / 10}%`, duration: 1.5, ease:"power2.out"});
					_this.observer.unobserve(_this);
				}
	    },
			{
	      threshold: [0, 1],
				rootMargin: '0% 0% -20% 0%'
	    });
	  }
		connectedCallback() {
			this.slider.addEventListener('input', this.onInput.bind(this));

			// Make divider draggable (only for product carousel, not regular before-after sections)
			const dividerWrapper = this.querySelector('.before-after-image--divider-wrapper');
			const isInCarousel = !!this.closest('.product-images__slide--before-after');

			if (dividerWrapper && isInCarousel) {
				const updatePosition = (e) => {
					const rect = this.getBoundingClientRect();
					const x = (e.clientX || e.touches?.[0]?.clientX) - rect.left;
					const percent = Math.max(0, Math.min(1000, (x / rect.width) * 1000));
					this.slider.value = percent;
					this.onInput();
				};

				dividerWrapper.addEventListener('mousedown', (e) => {
					updatePosition(e);
					e.preventDefault();

					// Reset Flickity state
					const productSlider = document.querySelector('#Product-Slider');
					if (productSlider && productSlider.flkty) {
						const flkty = productSlider.flkty;
						flkty.isDragging = false;
						flkty.isPointerDown = false;
						flkty.dragX = 0;
						flkty.dragY = 0;
						flkty.startPosition = flkty.x;
						flkty.velocity = 0;
					}

					const handleMove = (ev) => updatePosition(ev);
					const handleEnd = () => {
						window.removeEventListener('mousemove', handleMove);
						window.removeEventListener('mouseup', handleEnd);
					};

					window.addEventListener('mousemove', handleMove);
					window.addEventListener('mouseup', handleEnd);
				});

				dividerWrapper.addEventListener('touchstart', (e) => {
					updatePosition(e);

					const productSlider = document.querySelector('#Product-Slider');
					if (productSlider && productSlider.flkty) {
						productSlider.flkty.unbindHandles();
					}

					const handleMove = (ev) => {
						if (ev.touches) updatePosition(ev);
					};
					const handleEnd = () => {
						window.removeEventListener('touchmove', handleMove);
						window.removeEventListener('touchend', handleEnd);

						if (productSlider && productSlider.flkty) {
							productSlider.flkty.bindHandles();
						}
					};

					window.addEventListener('touchmove', handleMove);
					window.addEventListener('touchend', handleEnd);
				});
			}

			if ( document.body.classList.contains('animations-true') ) {
				this.parent.style.setProperty('--percent', '0%');
				this.observer.observe(this);
			}
		}
		onInput(e) {
			const percent = `${this.slider.value / 10}%`;
			// For product carousel, set on before-after element itself
			if (this.targetElement && this.targetElement !== this.parent) {
				this.targetElement.style.setProperty('--percent', percent);
			}
			// Set on parent (for regular sections and backwards compatibility)
			if (this.parent) {
				this.parent.style.setProperty('--percent', percent);
			}
		}
	}
	customElements.define('before-after', BeforeAfter);
}
